import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { TypeGroupIds } from "../../../constants/category-groupid.constants";

@Injectable()
export class AddEditAddressModalService {
    appCore = '';

    constructor(private http: HttpClient) {
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
    }

    getAccountAddressTypes() {
        return this.http.get<any>(`${environment.coreUrl}Type?groupId=${TypeGroupIds.AddressTypeCoreAPI}`);
    }

    getAccountAddressClasses() {
      return this.http.get<any>(`${environment.coreUrl}Type?groupId=${TypeGroupIds.AddressClassCoreAPI}`);
    }

    getAllCountries() {
        return this.http.get<any>(this.appCore + 'Country')
    }

    getAllStates(countryId: number) {
        return this.http.get<any>(this.appCore + 'State', {
          params: new HttpParams().append("countryId", `${countryId}`)
        })
          .toPromise()
          .then(res => res);
    }

    getAllCities(stateId: number) {
        return this.http.get<any>(this.appCore + 'City', {
          params: new HttpParams().append("stateId", `${stateId}`)
        })
          .toPromise()
          .then(res => res);
    }

    getCitiesByStates(objectId, templateId, stateIds, countryId, subterrid = 0) {
        return this.http.get<any>(`${environment.apiUrl}City/CityList?objectId=${objectId}&typeId=${templateId}&countryId=${countryId}&stateIdList=${stateIds}&subTerritoryId=${subterrid||0}`)
            .toPromise()
            .then(res => res);
    }

  addState(data: object) {
    return this.http.post<any>(this.appCore + 'State', data)
    .toPromise()
    .then(res => res);
  }

  addCity(data: object) {
    return this.http.post<any>(this.appCore + 'City', data)
    .toPromise()
    .then(res => res);
  }

  getAllContactRoles() {
    return this.http.get<any>(`${environment.coreUrl}Type?groupId=${TypeGroupIds.JobFuctionsContactAPI}`);
  }

}
